import { all } from "redux-saga/effects";
import authWatcher from "./authentication/saga";
import profileWatcher from "./profile/saga";
import statusWatcher from "./status/saga";
import complaintsWatcher from "./complaints/saga";
import proceduresWatcher from "./procedures/saga";
import workforceWatcher from "./workforce/saga";
import sensorsWatcher from "./sensors/saga";
import locationsWatcher from "./locations/saga";
import surveillanceWatcher from "./surveillance/saga";
import tableWatcher from "./table/saga";
import tracksWatcher from "./track/saga";
import procedureHistoryWatcher from "./proceduresHistory/saga";
import reportsWatcher from "./reports/saga";
import notificationsWatcher from "./notifications/saga";
import supportWatcher from "./support/saga";

export default function* rootSaga() {
  yield all([
    authWatcher(),
    profileWatcher(),
    statusWatcher(),
    complaintsWatcher(),
    tracksWatcher(),
    locationsWatcher(),
    proceduresWatcher(),
    procedureHistoryWatcher(),
    workforceWatcher(),
    sensorsWatcher(),
    surveillanceWatcher(),
    tableWatcher(),
    reportsWatcher(),
    notificationsWatcher(),
    supportWatcher()
  ]);
}
